<template>
  <div v-if="showCreditCard">
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__1">Credit Access Check</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Credit Access Check - Promotional Pricing Details</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Promotional Offer:
      </v-col>
      <v-col :cols="1" class="text-left no-left no-bottom no-top">
        <v-checkbox label="Yes" v-model="promotional_offer" />
      </v-col>
    </v-row>
    <div v-if="promotional_offer">
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Balance Transfer Introduction APR (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_1_balance_transfer_introduction_apr" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Balance Transfer Introductory Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_1_balance_transfer_introductory_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Balance Transfer Introduction APR (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_balance_transfer_introduction_apr" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Balance Transfer Introductory Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_balance_transfer_introductory_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Balance Transfer Introductory Usage Fee (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="balance_transfer_introductory_usage_fee" />
        </v-col>
      </v-row>
    <!-- make v-model for tier 2  -->
      <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Balance Transfer Introductory Usage Fee (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_balance_transfer_introductory_usage_fee" />
        </v-col>
      </v-row>

      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1  Balance Transfer Introductory Minimum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="balance_transfer_introductory_minimum_fee" />
        </v-col>
      </v-row>

     <!-- make v-model for tier 2  -->
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
         Tier 2 Balance Transfer Introductory Minimum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_balance_transfer_introductory_minimum_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Balance Transfer Introductory Maximum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="balance_transfer_introductory_maximum_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Balance Transfer Introductory Fee Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="balance_transfer_introductory_fee_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Cash Advance Introductory APR (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_1_cash_advance_introductory_apr" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Cash Advance Introductory Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_1_cash_advance_introductory_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Cash Advance Introductory APR (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_cash_advance_introductory_apr" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Cash Advance Introductory Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_cash_advance_introductory_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Cash Advance Introductory Usage Fee (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="cash_advance_introductory_usage_fee" />
        </v-col>
      </v-row>
      <!-- <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Cash Advance Introductory Usage Fee (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field/>
            </v-col>
        </v-row> -->
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Cash Advance Introductory Minimum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="cash_advance_introductory_minimum_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Cash Advance Introductory Maximum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="cash_advance_introductory_maximum_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Cash Advance Introductory Fee Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="cash_advance_introductory_fee_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Purchase Introductory APR (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_1_purchase_introductory_apr" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 1 Purchase Introductory Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_1_purchase_introductory_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Purchase Introductory APR (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_purchase_introductory_apr" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Tier 2 Purchase Introductory Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="tier_2_purchase_introductory_period" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Purchase Introductory Usage Fee (%):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="purchase_introductory_usage_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Purchase Introductory Minimum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="purchase_introductory_minimum_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Purchase Introductory Maximum Fee ($):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="purchase_introductory_maximum_fee" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          Purchase Introductory Fee Period (Months):
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field outlined v-model="purchase_introductory_fee_period" />
        </v-col>
      </v-row>
    </div>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Credit Access Check - Regular Pricing</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="balance_transfer_regular_apr" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Regular Rate Type:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select :items="rate_type_options" dense outlined v-model="balance_transfer_regular_rate_type"></v-select>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Usage Fee (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="balance_transfer_usage_fee" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Minimum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="balance_transfer_minimum_fee" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Maximum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="balance_transfer_maximum_fee" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="cash_advance_regular_apr" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Regular Rate Type:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select :items="rate_type_options" dense outlined v-model="cash_advance_regular_rate_type"></v-select>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Usage Fee (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="cash_advance_usage_fee" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Minimum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="cash_advance_minimum_fee" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Maximum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="cash_advance_maximum_fee" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Purchase Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined v-model="perchase_regular_apr" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Purchase Regular Rate Type:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select :items="rate_type_options" dense outlined v-model="perchase_regular_rate_type"></v-select>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "CreditCard",
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    //rate_type_options: [{text:'Select One',value:''},{text:'Fixed',value:1},{text:'Variable(Prime)',value:2},{text:'Variable(LIBOR)',value:3}]
  }),
  props: [
    "showCreditCard"
  ],
  computed: {
    ...mapGetters({
      sector: 'ProductData/getSector',
      category: 'ProductData/getCategory',
      rate_type_options: 'ProductData/getPaymentRateTypes'
    }),
    promotional_offer: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPromotionalOffer']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPromotionalOffer', o)
      }

    },
    tier_1_balance_transfer_introduction_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier1BalanceTransferIntroductionApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier1BalanceTransferIntroductionApr', o)
      },
    },
    tier_1_balance_transfer_introductory_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier1BalanceTransferIntroductoryPeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier1BalanceTransferIntroductoryPeriod', o)
      },
    },
    tier_2_balance_transfer_introduction_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2BalanceTransferIntroductionApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2BalanceTransferIntroductionApr', o)
      },
    },
    tier_2_balance_transfer_introductory_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2BalanceTransferIntroductoryPeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2BalanceTransferIntroductoryPeriod', o)
      },
    },
    balance_transfer_introductory_usage_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferIntroductoryUsageFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferIntroductoryUsageFee', o)
      },
    },
    // New field added here 
    tier_2_balance_transfer_introductory_usage_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2BalanceTransferIntroductoryUsageFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2BalanceTransferIntroductoryUsageFee', o)
      },
    },
    balance_transfer_introductory_minimum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferIntroductoryMinimumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferIntroductoryMinimumFee', o)
      },
    },
    tier_2_balance_transfer_introductory_minimum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2BalanceTransferIntroductoryMinimumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2BalanceTransferIntroductoryMinimumFee', o)
      },
    },
    balance_transfer_introductory_maximum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferIntroductoryMaximumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferIntroductoryMaximumFee', o)
      },
    },
    balance_transfer_introductory_fee_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferIntroductoryFeePeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferIntroductoryFeePeriod', o)
      },
    },
    tier_1_cash_advance_introductory_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier1CashAdvanceIntroductoryApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceIntroductoryApr', o)
      },
    },
    tier_1_cash_advance_introductory_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier1CashAdvanceIntroductoryPeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier1CashAdvanceIntroductoryPeriod', o)
      },
    },
    tier_2_cash_advance_introductory_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2CashAdvanceIntroductoryApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2CashAdvanceIntroductoryApr', o)
      },
    },
    tier_2_cash_advance_introductory_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2CashAdvanceIntroductoryPeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceTier2IntroductoryAprPeriod', o)
      },
    },
    cash_advance_introductory_usage_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceIntroductoryUsageFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceIntroductoryUsageFee', o)
      },
    },
    cash_advance_introductory_minimum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceIntroductoryMinimumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceIntroductoryMinimumFee', o)
      },
    },
    cash_advance_introductory_maximum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceIntroductoryMaximumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceIntroductoryMaximumFee', o)
      },
    },
    cash_advance_introductory_fee_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceIntroductoryFeePeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceIntroductoryFeePeriod', o)
      },
    },
    tier_1_purchase_introductory_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier1PurchaseIntroductoryApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier1PurchaseIntroductoryApr', o)
      },
    },
    tier_1_purchase_introductory_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier1PurchaseIntroductoryPeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier1PurchaseIntroductoryPeriod', o)
      },
    },
    tier_2_purchase_introductory_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2PurchaseIntroductoryApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2PurchaseIntroductoryApr', o)
      },
    },
    tier_2_purchase_introductory_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardTier2PurchaseIntroductoryPeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardTier2PurchaseIntroductoryPeriod', o)
      },
    },
    purchase_introductory_usage_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPurchaseIntroductoryUsageFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPurchaseIntroductoryUsageFee', o)
      },
    },
    purchase_introductory_minimum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPurchaseIntroductoryMinimumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPurchaseIntroductoryMinimumFee', o)
      },
    },
    purchase_introductory_maximum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPurchaseIntroductoryMaximumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPurchaseIntroductoryMaximumFee', o)
      },
    },
    purchase_introductory_fee_period: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPurchaseIntroductoryFeePeriod']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPurchaseIntroductoryFeePeriod', o)
      },
    },
    balance_transfer_regular_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferRegularApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferRegularApr', o)
      },
    },
    balance_transfer_regular_rate_type: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferRegularRateType']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferRegularRateType', o)
      },
    },
    balance_transfer_usage_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferUsageFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferUsageFee', o)
      },
    },
    balance_transfer_minimum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferMinimumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferMinimumFee', o)
      },
    },
    balance_transfer_maximum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardBalanceTransferMaximumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardBalanceTransferMaximumFee', o)
      },
    },
    cash_advance_regular_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceRegularApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceRegularApr', o)
      },
    },
    cash_advance_regular_rate_type: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceRegularRateType']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceRegularRateType', o)
      },
    },
    cash_advance_usage_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceUsageFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceUsageFee', o)
      },
    },
    cash_advance_minimum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceMinimumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceMinimumFee', o)
      },
    },
    cash_advance_maximum_fee: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardCashAdvanceMaximumFee']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardCashAdvanceMaximumFee', o)
      },
    },
    perchase_regular_apr: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPerchaseRegularApr']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPerchaseRegularApr', o)
      },
    },
    perchase_regular_rate_type: {
      get: function () {
        return this.$store.getters['ProductData/getCreditCardPerchaseRegularRateType']
      },
      set: function (o) {
        this.$store.dispatch('ProductData/setCreditCardPerchaseRegularRateType', o)
      },
    },
  }
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>